// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3LpU9","row":"Node_row__56pd0","label":"Node_label__GI8qs","footer":"Node_footer__3K8pT"};